import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import './custom.css';
import './bootstrap.min.css';
import './hover.css';
import './jquery.datetimepicker.css';
import './owl.theme.default.min.css';
// import './owlCarouselMin.css';
import './style.css';
import './vendor.bundle.base.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
